export default __webpack_public_path__ + "static/media/animal.389ffe15.png";